import { StateModel } from '../../shared/models/default-state.model';
import {
  GET_LIST_ELEMENT_REQUEST,
  GET_LIST_ELEMENT_SUCCESS,
  GET_LIST_ELEMENT_ERROR,
  CREATE_LIST_ELEMENT_REQUEST,
  CREATE_LIST_ELEMENT_SUCCESS,
  CREATE_LIST_ELEMENT_ERROR,
  UPDATE_LIST_ELEMENT_REQUEST,
  UPDATE_LIST_ELEMENT_SUCCESS,
  UPDATE_LIST_ELEMENT_ERROR,
  LIST_ELEMENT_CLEAR_ERROR,
} from '../actions/lists.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export interface ListElementModel {
  createdAt?: string;
  description?: string;
  id?: number;
  name?: string;
  tenantId?: number;
  updatedAt?: string;
}

export const listElementReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_LIST_ELEMENT_REQUEST:
    case CREATE_LIST_ELEMENT_REQUEST:
    case UPDATE_LIST_ELEMENT_REQUEST:
      return {
        ...state,
        loaded: false,
        loading: true,
        error: null,
      };

    case GET_LIST_ELEMENT_SUCCESS:
    case CREATE_LIST_ELEMENT_SUCCESS:
    case UPDATE_LIST_ELEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };

    case GET_LIST_ELEMENT_ERROR:
    case CREATE_LIST_ELEMENT_ERROR:
    case UPDATE_LIST_ELEMENT_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case LIST_ELEMENT_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default listElementReducer;
